import { call, put } from "redux-saga/effects";
import PlanActions from "./plan-actions";
import * as api from "../../services/api";

export function* createPlan(action) {
    const { plan } = action;
    const response = yield call(api.createPlan, plan);

    if (response.ok) {
        yield put(PlanActions.planCreateSuccess(response.data));
    } else {
        yield put(PlanActions.planCreateFailure(response.data));
    }
}

export function* updatePlan(action) {
    const { plan, planId } = action;
    const response = yield call(api.updatePlan, planId, plan);

    if (response.ok) {
        yield put(PlanActions.planUpdateSuccess(response.data));
    } else {
        yield put(PlanActions.planUpdateFailure(response.data));
    }
}

export function* addWatchersToPlan(action) {
    const { watchers } = action;
    const response = yield call(api.addWatchersToPlan, watchers);

    if (response.ok) {
        yield put(PlanActions.planAddWatchersSuccess(response.data));
    } else {
        yield put(PlanActions.planAddWatchersFailure(response.data));
    }
}

export function* removeWatcherFromPlan(action) {
    const { watcherId } = action;
    const response = yield call(api.removeWatcherFromPlan, watcherId);

    if (response.ok) {
        yield put(PlanActions.planRemoveWatcherSuccess());
    } else {
        yield put(PlanActions.planRemoveWatcherFailure(response.data));
    }
}

export function* getAllWatchers(action) {
    const { planId } = action;
    const response = yield call(api.getAllWatchers, planId);

    if (response.ok) {
        yield put(PlanActions.planAllWatchersSuccess(response.data));
    } else {
        yield put(PlanActions.planAllWatchersFailure(response.data));
    }
}
